import React, {Suspense} from 'react';
import ReactDOM from 'react-dom/client';
import {initGtagStub} from './utils/analytics';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from 'react-redux';
import {I18nextProvider} from 'react-i18next';
import i18next from 'i18next';
import store from './store';
import configI18next from './config/configI18next';
import {initAxios} from './library/axios';
import TickchakLoader from './component/tickchakLoader/TickchakLoader';
import 'setimmediate';

initGtagStub();

configI18next();
initAxios();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    
    <React.StrictMode>
        <Provider store={store}>
            <I18nextProvider i18n={i18next}>
                <Suspense fallback={<TickchakLoader showClass="show" cssStyle="position:fixed;" />}>
                    <App />
                </Suspense>
            </I18nextProvider>
        </Provider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
